import type { GmStatusKey } from '../types/statusRewards';
import type { ProgressStatusDto } from '@/queries/progress-statuses/progress-statuses.schema';
import { statusKeys } from '../constants/statusKeys';

export const getStatusKey = (status?: Pick<ProgressStatusDto, 'name' | 'presentation'> | null): GmStatusKey | undefined => {
  if (!status) {
    return undefined;
  }

  const presentationKey = status.presentation?.key?.toLowerCase();
  const statusName = status.name.toLowerCase();
  return statusKeys.find(key => key === presentationKey)
    ?? statusKeys.find(key => key === statusName);
};
